const SELECTION_SCOPE_HALL = 'hall';
const SELECTION_SCOPE_SECTOR = 'sector';
const SELECTION_SCOPE_ROW = 'row';
const SELECTION_SCOPE_ROUND_TABLE = 'round_table';
const SELECTION_SCOPE_RECTANGLE_TABLE = 'rectangle_table';

export {
    SELECTION_SCOPE_HALL,
    SELECTION_SCOPE_SECTOR,
    SELECTION_SCOPE_ROW,
    SELECTION_SCOPE_ROUND_TABLE,
    SELECTION_SCOPE_RECTANGLE_TABLE,
};
